import FixedAmountIcon from "@apps/rewards/widgets/rewards_hub_widget/v1/components/icons/SpendingRuleIcons/FixedAmountIcon.svelte";
import FreeProductIcon from "@apps/rewards/widgets/rewards_hub_widget/v1/components/icons/SpendingRuleIcons/FreeProductIcon.svelte";
import FreeShippingIcon from "@apps/rewards/widgets/rewards_hub_widget/v1/components/icons/SpendingRuleIcons/FreeShippingIcon.svelte";
import GiftCardIcon from "@apps/rewards/widgets/rewards_hub_widget/v1/components/icons/SpendingRuleIcons/GiftCardIcon.svelte";
import PercentageIcon from "@apps/rewards/widgets/rewards_hub_widget/v1/components/icons/SpendingRuleIcons/PercentageIcon.svelte";
import type { ComponentType } from "svelte";

import { REWARDS_SPENDING_RULES_TYPES } from "./constants";
import type { RewardsSpendingRulesType } from "./types";

export const REWARDS_SPENDING_RULE_ICONS: Record<
    RewardsSpendingRulesType,
    ComponentType
> = {
    [REWARDS_SPENDING_RULES_TYPES.amountDiscount]: FixedAmountIcon,
    [REWARDS_SPENDING_RULES_TYPES.percentageDiscount]: PercentageIcon,
    [REWARDS_SPENDING_RULES_TYPES.giftCard]: GiftCardIcon,
    [REWARDS_SPENDING_RULES_TYPES.freeProduct]: FreeProductIcon,
    [REWARDS_SPENDING_RULES_TYPES.freeShipping]: FreeShippingIcon,
    [REWARDS_SPENDING_RULES_TYPES.storeCredit]: GiftCardIcon,
};
